// ── QR Scanner — real camera-based scan ──────────────────────────────────
// Uses jsQR (loaded from CDN) to read QR codes from camera stream.
// Used by CMLDashboard for event check-in.

// ── Load jsQR dynamically ────────────────────────────────────────────────
let jsQR = null;
async function loadJsQR() {
  if (jsQR) return jsQR;
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/jsqr@1.4.0/dist/jsQR.min.js';
    script.onload = () => { jsQR = window.jsQR; resolve(jsQR); };
    script.onerror = () => reject(new Error('Failed to load jsQR'));
    document.head.appendChild(script);
  });
}

// ── Start camera scan — returns { stop } ─────────────────────────────────
export async function startQRScanner(videoEl, canvasEl, onResult, onError) {
  try {
    const lib = await loadJsQR();
    const stream = await navigator.mediaDevices.getUserMedia({
      video: { facingMode: 'environment', width: { ideal: 1280 } }
    });
    videoEl.srcObject = stream;
    await videoEl.play();

    const ctx = canvasEl.getContext('2d');
    let active = true;

    const scan = () => {
      if (!active || videoEl.readyState < videoEl.HAVE_ENOUGH_DATA) {
        if (active) requestAnimationFrame(scan);
        return;
      }
      canvasEl.width  = videoEl.videoWidth;
      canvasEl.height = videoEl.videoHeight;
      ctx.drawImage(videoEl, 0, 0);
      const imageData = ctx.getImageData(0, 0, canvasEl.width, canvasEl.height);
      const code = lib(imageData.data, imageData.width, imageData.height);
      if (code) {
        onResult(code.data);
        return; // Stop after first successful scan
      }
      requestAnimationFrame(scan);
    };

    requestAnimationFrame(scan);
    return {
      stop: () => {
        active = false;
        stream.getTracks().forEach(t => t.stop());
      }
    };
  } catch (err) {
    onError?.(err.name === 'NotAllowedError'
      ? 'Camera access denied. Enable it in browser settings.'
      : err.message);
    return { stop: () => {} };
  }
}

// ── Parse BeeLove QR code ─────────────────────────────────────────────────
// Format: beelove:event:{eventId}:user:{userId}
export function parseBeeLoveQR(data) {
  const m = data.match(/^beelove:event:([^:]+):user:([^:]+)$/);
  if (!m) return null;
  return { eventId: m[1], userId: m[2] };
}
